import { createContext, useContext } from 'react'

const VariablesContext = createContext<any>({})
const useVariables = () => useContext(VariablesContext)
export { VariablesContext, useVariables }
